import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const PaginatorContainer = styled.nav({
  margin: `${tokens.spacing[6]} 0`,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[600],
  gap: tokens.spacing[5],
  flexWrap: 'wrap'
})

export const PageButton = styled.button<{ active?: boolean }>(
  {
    display: 'block',
    padding: `${tokens.spacing[4]} ${tokens.spacing[5]}`,
    color: 'inherit',
    fontSize: 'inherit',
    // use box-shadow to imitate inset border
    boxShadow: `0px 0px 0px 1px ${tokens.color.airJordan[200]} inset`,
    cursor: 'pointer'
  },
  ({ active }) =>
    active && {
      color: tokens.color.airJordan.p,
      borderColor: tokens.color.airJordan.p,
      borderWidth: tokens.borderWidth.s,
      boxShadow: `0px 0px 0px 2px ${tokens.color.airJordan.p} inset`
    }
)

export const PrevNextButton = styled(PageButton)({
  [mediaQuery.m.max]: {
    display: 'none'
  }
})
